<template>
  <section class="samplePoint p-4 space-y-4">
    <viewTitle title="业务管理 / 基础数据管理 / 取样点" :showReturn="false" />
    <el-button
      v-has="['c-base-mp-sampling-add']"
      @click="onAdd"
      size="medium"
      type="primary"
      >添加</el-button
    >
    <el-button
      v-has="['c-base-mp-sampling-delete']"
      @click="onDelete"
      size="medium"
      >删除</el-button
    >
    <div class="space-x-4 text-sm">
      <span>
        车辆业务类型
      </span>
      <el-input
        v-model="queryParam.car_business_name"
        clearable
        placeholder="请输入车辆业务类型"
        class="w-60"
      ></el-input>
      <span>
        取样点名称
      </span>
      <el-input
        v-model="queryParam.name"
        clearable
        placeholder="请输入取样点名称"
        class="w-60"
      ></el-input>
      <span>
        状态
      </span>
      <el-select v-model="queryParam.state" clearable>
        <el-option label="启用" value="1"></el-option>
        <el-option label="禁用" value="2"></el-option>
      </el-select>
    </div>
    <c-table
      :isIndex="false"
      :data="dataSource"
      :columns="columns"
      :query.sync="pagintion"
      :total="total"
      @loadPage="loadData"
    >
      <template slot="update_time" slot-scope="scope">
        {{ scope.row.update_time | timeFormat }}
      </template>
      <template slot="car_business_list" slot-scope="{ row }">
        <template
          v-if="row.car_business_list && row.car_business_list.length > 0"
        >
          <div
            class="text-left"
            v-for="item in row.car_business_list"
            :key="row.car_business_id"
          >
            {{ item.car_business_name }}（{{ item.sampling_ratio }}%）
          </div>
        </template>
        <template v-else>--</template>
      </template>
      <template slot="action" slot-scope="scope">
        <el-row type="flex" justify="space-around" align="middle">
          <c-link
            v-has="['c-base-mp-sampling-update']"
            @click="onEdit(scope.row)"
            label="修改"
          ></c-link>
          <c-link
            v-has="['c-base-mp-sampling-delete']"
            @click="onDelete(scope.row, 1)"
            label="删除"
            type="danger"
          ></c-link>
          <c-link
            v-has="['c-base-mp-sampling-switch']"
            v-if="scope.row.state == 2"
            @click="onStart(scope.row)"
            label="启用"
            type="success"
          ></c-link>
          <c-link
            v-has="['c-base-mp-sampling-switch']"
            v-if="scope.row.state == 1"
            @click="onStop(scope.row)"
            label="禁用"
            type="warning"
          ></c-link>
        </el-row>
      </template>
    </c-table>
  </section>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      total: 0,
      tableData: [],
      columns: [
        {
          label: "基地",
          prop: "name",
          formatData: () => this.baseInfo.com_name
        },
        {
          label: "车辆业务类型",
          prop: "car_business_list"
          //  formatData: (row) => {
          //     return row.car_business_list.map((e) => e.car_business_name).join(";")
          //  }
        },
        { label: "取样点名称", prop: "name" },
        {
          width: 80,
          label: "状态",
          prop: "state",
          formatData: row => {
            return row.state == 1 ? "启用" : "禁用";
          }
        },
        // { label: '维护人', prop: 'update_name' },
        { width: 180, label: "最近维护时间", prop: "update_time" },
        { width: 150, label: "操作", prop: "action" }
      ],
      selection: [],
      fetchDataEvent: params =>
        this.$common.http({
          url: "/api/queue/admin/query_sampling_point",
          data: params
        }),
      deleteConfig: {
        title: "删除", // 标题
        content: "确认删除取样点？删除后数据将不可恢复！",
        url: "/api/queue/admin/delete_sampling_point"
      }
    };
  },
  computed: {
    ...mapGetters(["baseInfo"])
  },
  mixins: [initListMinxin, mixinTableLyout],
  methods: {
    onAdd() {
      this.$router.push({
        path: "/rhqy/service/basic/samplePointDetail/0"
      });
    },
    onEdit(row) {
      this.$router.push({
        path: "/rhqy/service/basic/samplePointDetail/" + row.id
      });
    },
    onStart(row) {
      this.$confirm("是否启用取样点?", "提示").then(() => {
        this.onSwicth(row.id, 1);
      });
    },
    onStop(row) {
      this.$confirm("是否禁用取样点?", "提示").then(() => {
        this.onSwicth(row.id, 2);
      });
    },
    onSwicth(id, state) {
      this.$common
        .http({
          url: "/api/queue/admin/switch_sampling_point",
          data: { id, state }
        })
        .then(() => {
          this.$message.success("操作成功");
          this.loadData();
        });
    }
  }
};
</script>
